import { createContext, useContext } from 'react'
import { OrganizationBranchDataFragment } from '../generated/graphql'

export interface BranchContextInterface {
  branch?: OrganizationBranchDataFragment
  setBranch(branch?: OrganizationBranchDataFragment): void
}

export const BranchContext = createContext<BranchContextInterface>({
  branch: null,
  setBranch: () => {
    /* */
  },
})

export const useBranchContext = () => useContext(BranchContext)
